// @flow
import {eventChannel, type SagaIterator, type Emit, type Channel} from 'redux-saga';

import {put, takeLatest, call} from 'redux-saga/effects';
import {visibilityMenu} from 'actions/menu/mainMenu';

/**
 * Create eventChannel
 * @return {function} channel creator
 */
export const createOpenMenuChannel = (): Channel =>
    eventChannel((emitter: Emit): (() => void) => {
        const listener = (event: CustomEvent) => {
            emitter(event);
        };

        window.addEventListener('menu:openMenu', listener);
        return () => {
            window.removeEventListener('menu:openMenu', listener);
        };
    });

/**
 * Throw an action to be open the menu
 */
export function* openMenu(): SagaIterator {
    yield put(visibilityMenu(true));
}

/**
 * Begin of saga
 */
export default function* menuSaga(): SagaIterator {
    const openMenuChannel = yield call(createOpenMenuChannel);
    yield takeLatest(openMenuChannel, openMenu);
}
